"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameworkLicencee = void 0;
exports.frameworkLicencee = {
    organizationName: 'IoT Ventures',
};
